/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type UseQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useQueryResultOnError<E>(
  queryResult: UseQueryResult<unknown, E>,
  onError: ((error: E) => void) | undefined,
) {
  useEffect(() => {
    if (queryResult.isError) {
      onError?.(queryResult.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryResult.isError, queryResult.error]);
}
